import { render, staticRenderFns } from "./EmptyPageLayout.vue?vue&type=template&id=20e6e742"
import script from "./EmptyPageLayout.vue?vue&type=script&lang=js"
export * from "./EmptyPageLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports